export default () => ({
  component: 'coupon-bonus-type-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
